// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__mf0GI","logo":"MainNavigation_logo__AfdRs","nav":"MainNavigation_nav__xpVgX","active":"MainNavigation_active__Zc0Ao"};